import Box from '@mui/material/Box'
import type { BoxProps } from '@mui/material/Box'

interface ContainerProps extends BoxProps {
  narrow?: boolean
}

export default function Container({ narrow, children, sx, ...props }: ContainerProps) {
  return (
    <Box
      sx={{
        maxWidth: narrow ? 800 : 1200,
        mx: 'auto',
        px: { xs: 3, md: 4 },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  )
}
